import { z } from 'zod';
// ---------------------------------------------------------------------------
// 날씨 스키마 — 앱 WeatherCard 가 소비하는 API 응답 계약
//   백엔드(api)가 외부 기상 API(KMA 단기예보)를 가공해 이 형태로 반환한다.
// ---------------------------------------------------------------------------
/** 정규화된 날씨 상태 코드 (아이콘 매핑 키) */
export const WEATHER_CODES = [
    'sunny',
    'partly_cloudy_day',
    'cloudy',
    'rainy',
    'snowy',
    'thunderstorm',
];
export const WeatherCodeSchema = z.enum(WEATHER_CODES);
/** 현재 날씨 */
export const WeatherNowSchema = z.object({
    city: z.string(),
    temp: z.number(),
    code: WeatherCodeSchema,
    desc: z.string(),
    hi: z.number(),
    lo: z.number(),
});
/** 일별 예보 (오늘 + N일) */
export const WeatherDaySchema = z.object({
    d: z.string(),
    code: WeatherCodeSchema,
    hi: z.number(),
    lo: z.number(),
    rain: z.number().int().min(0).max(100),
});
/** 시간별 예보 1건 (향후 24시간) */
export const WeatherHourSchema = z.object({
    time: z.string(), // ISO 8601 (KST offset 포함)
    temp: z.number(), // 기온 °C
    code: WeatherCodeSchema, // 정규화 날씨 코드(아이콘 키)
    pop: z.number().int().min(0).max(100), // 강수확률 %
    reh: z.number().int().min(0).max(100), // 상대습도 %
    pcp: z.number().min(0), // 강수량 mm (강수없음=0)
});
/** 날씨 스냅샷 — 현재 + 가변 길이 일별 예보 + (선택) 시간별 */
export const WeatherSnapshotSchema = z.object({
    now: WeatherNowSchema,
    week: z.array(WeatherDaySchema),
    hourly: z.array(WeatherHourSchema).optional(),
});
//# sourceMappingURL=weather.js.map